import React from 'react';
import { Link } from 'react-router-dom';

const Footer = ({ isAdmin, onLogout }) => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer style={styles.footer}>
      <div style={styles.copyright}>
        © {currentYear} Eurocentrum. Všetky práva vyhradené.
        <span style={styles.loginContainer}>
          {!isAdmin ? (
            <Link to="/login" style={styles.loginLink}>Admin</Link>
          ) : (
            <button onClick={onLogout} style={styles.logoutButton}>Logout</button>
          )}
        </span>
      </div>
    </footer>
  );
};

const styles = {
  footer: {
    width: '100%',
    padding: '1rem 0',
    backgroundColor: '#f8f9fa',
    borderTop: '1px solid #e9ecef',
    textAlign: 'center',
    marginTop: 'auto', // Push to bottom when possible
  },
  copyright: {
    color: '#6c757d',
    fontSize: '14px',
    fontFamily: 'Inter, system-ui, sans-serif',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
  },
  loginContainer: {
    marginLeft: '8px',
  },
  loginLink: {
    color: '#6c757d',
    textDecoration: 'none',
    fontSize: '14px',
    opacity: 0.7,
    transition: 'opacity 0.2s ease',
    '&:hover': {
      opacity: 1,
    }
  },
  logoutButton: {
    background: 'transparent',
    color: '#6c757d',
    border: 'none',
    padding: '0',
    fontSize: '14px',
    cursor: 'pointer',
    opacity: 0.7,
    transition: 'opacity 0.2s ease',
    '&:hover': {
      opacity: 1,
    }
  }
};

export default Footer; 